<template>
  <nx-fullscreen-dialog
      :active="active"
      :title="$t('message.wizard.new.taxonomy')"
      @dismiss="$emit('dismiss')">

    <template slot="toolbar-items">
      <v-btn
          @click="create"
          color="accent"
          dark flat
          :disabled="!flags.valid"
      >{{ $t('message.wizard.createBtn') }}</v-btn>
    </template>

    <v-container py-3 fluid class="nx-taxonomy-wizard-body">
      <v-layout wrap fill-height>
        <v-flex class="md6 offset-md3 xs12">
          <nx-form class="nx-form" @form="flags = $event" @submit.stop="create">
            <div class="nx-form-fieldset">

              <nx-form-text
                  name="title"
                  :label="$t('message.form.fields.title')"
                  v-model="draft.title"
                  validation="required|min:20"
                  autofocus
              ></nx-form-text>

            </div>
          </nx-form>
        </v-flex>
      </v-layout>
    </v-container>

  </nx-fullscreen-dialog>
</template>

<script>
import Form from '@/modules/form/Form';
import FormText from '@/modules/form/components/FormText';
import FullscreenDialog from '@/components/dialogs/FullscreenDialog';
import Loadable from '@/mixins/loadable';
import Toast from '@/modules/toast/services';
import api from '../api';

export default {
  name: 'nx-taxonomy-wizard',
  mixins: [Loadable],
  components: {
    [Form.name]: Form,
    [FormText.name]: FormText,
    [FullscreenDialog.name]: FullscreenDialog,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      draft: {},
      flags: {},
    };
  },
  methods: {
    async create() {
      this.loadingStart();
      const response = await api.create({
        name: this.draft.title,
      }, 'section');
      this.loadingFinish();

      if (response) {
        const entity = {
          ...response,
          route: {
            name: 'taxonomy.editor',
            params: { type: response.type, id: response.id },
          },
        };
        this.$emit('entityCreated', entity);
        Toast.notify(this.$t('message.wizard.createSuccess'));
        this.$emit('dismiss');
      } else {
        Toast.notify(this.$t('message.wizard.createError'));
      }
    },
  },
};
</script>
